import { useQuery } from "@tanstack/react-query";
import { getMyFeedback } from "@/lib/api";
import { useScopedKey } from "@/lib/queryClient";
import type { FeedbackBundle } from "@/lib/types";

/**
 * The `/api/my-feedback` bundle hook (M7) — one round-trip feeding
 * every `/feedback` list tab.
 *
 * Scope-keyed: the backend resolves the viewer's team from the request
 * scope (`apiFetch` auto-injects `team_id` from the scope store), so
 * multi-team viewers must not reuse another active team's cached bundle.
 * Include both active team and season in the query key so scope changes
 * remount the feedback bundle in a pending state instead of showing stale
 * notes/reviews from the previous team while the refetch is in flight.
 *
 * `enabled` is left default-on: a viewer with no resolved scope
 * gets a 401/409 surfaced as `query.error`, which the shell turns
 * into the inline login / "ask a coach" state — same pattern as
 * the coach surfaces.
 */
export function useMyFeedback() {
  const queryKey = useScopedKey("my-feedback");
  return useQuery<FeedbackBundle>({
    queryKey,
    queryFn: getMyFeedback,
  });
}
